@if (is_loading) {
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
}



<div style="width: 850px;margin-left: 40px; margin-top: 40px">


<div>
  <mat-list>
    <mat-list-item>Campaigns</mat-list-item>
    <mat-divider></mat-divider>
  </mat-list>
</div>


  @if (campaign_group_id=='') {
    <ng-container>
      <span>Must select Campaign Group</span>
    </ng-container>
  }


  @if (client_id && campaign_group_id) {
  <ng-container>

  <div [hidden]="is_loading">


    <div style="margin-top: 20px; margin-bottom: 20px;">
      <button mat-fab aria-label="Add Client" (click)="addCampaign(false)" matTooltip="Add Client"
              matTooltipPosition="right">
        <mat-icon class="add-button">add</mat-icon>
      </button>
    </div>

    <mat-form-field>
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
    </mat-form-field>

    <div>
      <mat-card class="mat-elevation-z24">
        <div class="mat-elevation-z24">
          <table mat-table [dataSource]="dataSource" matSort>

            <!-- Campaign Column -->
            <ng-container matColumnDef="campaign_id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>CampaignID</th>
              <td mat-cell *matCellDef="let row">{{row.campaign_id}}</td>
            </ng-container>

            <!-- NameColumn -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let row">{{row.name}}</td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let row">{{row.status}}</td>
            </ng-container>


            <!-- View Column -->
            <ng-container matColumnDef="View">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>View</th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button class="any-icon-primary table-icon" (click)="viewData(row)">
                  <mat-icon color="accent">visibility</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="Edit">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Edit</th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button class="any-icon-primary table-icon" (click)="addCampaign(true,  row)">
                  <mat-icon color="accent" style="cursor: pointer;">edit</mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Delete Column -->
            <ng-container matColumnDef="Delete">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Delete</th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button class="warn-icon-primary table-icon" (click)="deleteRow(row)">
                  <mat-icon color="warn" style="cursor: pointer;">delete</mat-icon>
                </button>
              </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"
                (click)="getTableRecord(row)"></tr>
          </table>


          <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                         showFirstLastButtons
                         aria-label="Select page of periodic elements">
          </mat-paginator>
        </div>
      </mat-card>
    </div>


  </div>

</ng-container>
  }
</div>
